import { create } from 'zustand'

type GridPosition = { row: number; col: number }

export type NewFolderPlaceholderState = {
  position: GridPosition | null
}

export type NewFolderPlaceholderActions = {
  open(position: GridPosition): void
  close(): void
}

export const useNewFolderPlaceholderStore = create<
  NewFolderPlaceholderState & NewFolderPlaceholderActions
>(set => ({
  position: null,
  open: position => set(() => ({ position })),
  close: () => set(() => ({ position: null }))
}))
